import type { User } from '@/types'
import { hasNoCabinet } from '@/utils/userName'

/**
 * Кабинет ученика глазами учителя.
 *
 * - `has_cabinet` — ученик входит в EasyA сам (или признак не пришёл);
 * - `none` — кабинета нет и приглашения нет;
 * - `invited` — приглашение отправлено, ссылка действует;
 * - `expired` — приглашение есть, но срок ссылки истёк.
 */
export type CabinetInvitationState = 'has_cabinet' | 'none' | 'invited' | 'expired'

export function getCabinetInvitationState(
  user: Pick<User, 'has_cabinet' | 'cabinet_invitation'>,
): CabinetInvitationState {
  if (!hasNoCabinet(user)) {
    return 'has_cabinet'
  }

  const invitation = user.cabinet_invitation
  if (!invitation) {
    return 'none'
  }

  return invitation.is_expired ? 'expired' : 'invited'
}

/**
 * Может ли учитель выдать кабинет или распорядиться приглашением: ученик без
 * кабинета с активным договором — так же решает API (`UserPolicy::inviteToCabinet`,
 * `InvitationPolicy::resend`). С завершённым договором учитель статус видит,
 * но действий у него нет.
 */
export function canManageCabinet(user: Pick<User, 'has_cabinet' | 'contract'>): boolean {
  return hasNoCabinet(user) && user.contract?.status === 'active'
}
